import React, { useState } from 'react';
import DashboardWidgetNew from './DashboardWidgetNew';

const Authors = () => {
  const [filters, setFilters] = useState({});

  const getChartTitle = filters => {
    if (filters.operation === 'investment') {
      return 'Developer Investment Trends ($)';
    }
    if (filters.operation === 'git_effort') {
      return 'Developer Baseline Effort (REV) Trends';
    }
    return 'Developer Commit Trends';
  };

  const dashboardFilters = filter => {
    setFilters(filter);
  };

  return (
    <DashboardWidgetNew
      category="authors"
      dashboardFilters={dashboardFilters}
      isVisibleLangugageTags={true}
      isCheckContributionHeatmap={true}
      isHidden={['authors']}
      forceClearMultiFilters={['authors']}
      title={{
        chartTitle: getChartTitle(filters),
        pieTitle: 'Developers - Pie',
        tableColumnName: 'Developers'
      }}
    />
  );
};

export default Authors;
